export enum OrganizationIntegrationType {
  AIQ = 'AIQ',
  // BITLY = 'BITLY',
  INSIGHTLY = 'INSIGHTLY',
  MAILCHIMP = 'MAILCHIMP',
  // EVENTBRITE = 'EVENTBRITE',
  STRIPE = 'STRIPE',
  OMNIVORE = 'OMNIVORE',
  HELIOS = 'HELIOS',
  RPOWER = 'RPOWER',
  SILVERWARE = 'SILVERWARE',
  FACEBOOK = 'FACEBOOK',
  GOOGLE_TAG_MANAGER = 'GOOGLE_TAG_MANAGER',
  TOAST = 'TOAST',
  SQUARE = 'SQUARE',
  BILLFOLD = 'BILLFOLD',
  TABLELIST = 'TABLELIST',
  DISCOTECH = 'DISCOTECH',
  CYMBAL = 'CYMBAL',
  SWIVUL = 'SWIVUL',
}

export const MARKETPLACE_TYPES = [
  OrganizationIntegrationType.TABLELIST,
  OrganizationIntegrationType.DISCOTECH,
  OrganizationIntegrationType.CYMBAL,
  OrganizationIntegrationType.SWIVUL,
] as const

export type MarketplaceIntegrationType = (typeof MARKETPLACE_TYPES)[number]

export const MarketplaceTypeToPublishKey: Record<
  MarketplaceIntegrationType,
  'tablelist' | 'discotech' | 'cymbal' | 'swivul'
> = {
  [OrganizationIntegrationType.TABLELIST]: 'tablelist',
  [OrganizationIntegrationType.DISCOTECH]: 'discotech',
  [OrganizationIntegrationType.CYMBAL]: 'cymbal',
  [OrganizationIntegrationType.SWIVUL]: 'swivul',
}

export const isMarketplaceIntegrationType = (
  type: OrganizationIntegrationType
): type is MarketplaceIntegrationType =>
  (MARKETPLACE_TYPES as readonly OrganizationIntegrationType[]).includes(type)

export const organizationIntegrationPosTypes = [
  OrganizationIntegrationType.OMNIVORE,
  OrganizationIntegrationType.SILVERWARE,
  OrganizationIntegrationType.TOAST,
  OrganizationIntegrationType.SQUARE,
]

export const organizationIntegrationPosTypesWithCodes = [
  OrganizationIntegrationType.OMNIVORE,
]

export enum OrganizationIntegrationStatus {
  ACTIVE = 'ACTIVE',
  INACTIVE = 'INACTIVE',
}

export enum OrganizationIntegrationEvent {
  CREATED = 'ORGANIZATION_INTEGRATION_CREATED',
  UPDATED = 'ORGANIZATION_INTEGRATION_UPDATED',
}

export enum OrganizationIntegrationTypeName {
  AIQ = 'AIQ',
  // BITLY = 'Bitly',
  INSIGHTLY = 'Insightly',
  MAILCHIMP = 'Mailchimp',
  // EVENTBRITE = 'Eventbrite',
  STRIPE = 'Stripe',
  OMNIVORE = 'Omnivore',
  HELIOS = 'Helios',
  RPOWER = 'RPower',
  SILVERWARE = 'Silverware',
  FACEBOOK = 'Facebook',
  GOOGLE_TAG_MANAGER = 'Google Tag Manager',
  TOAST = 'Toast',
  SQUARE = 'Square',
  BILLFOLD = 'Billfold',
  TABLELIST = 'Tablelist',
  DISCOTECH = 'Discotech',
  CYMBAL = 'Cymbal',
  SWIVUL = 'Swivul',
}

export enum OrganizationIntegrationCategory {
  MARKETING = 'MARKETING',
  POS = 'POS',
  ANALYTICS = 'ANALYTICS',
  CRM = 'CRM',
  PAYMENTS = 'PAYMENTS',
  MARKETPLACE = 'MARKETPLACE',
}

export const OrganizationIntegrationCategoryName = {
  [OrganizationIntegrationCategory.MARKETING]: 'Marketing',
  [OrganizationIntegrationCategory.POS]: 'POS',
  [OrganizationIntegrationCategory.ANALYTICS]: 'Analytics',
  [OrganizationIntegrationCategory.PAYMENTS]: 'Payments',
  [OrganizationIntegrationCategory.CRM]: 'CRM',
  [OrganizationIntegrationCategory.MARKETPLACE]: 'Marketplace',
}

export const OrganizationIntegrationTypeToCategory: {
  [key in OrganizationIntegrationType]: OrganizationIntegrationCategory
} = {
  //marketing
  [OrganizationIntegrationType.AIQ]: OrganizationIntegrationCategory.MARKETING,
  [OrganizationIntegrationType.HELIOS]:
    OrganizationIntegrationCategory.MARKETING,
  [OrganizationIntegrationType.MAILCHIMP]:
    OrganizationIntegrationCategory.MARKETING,
  //analytics
  [OrganizationIntegrationType.FACEBOOK]:
    OrganizationIntegrationCategory.ANALYTICS,
  [OrganizationIntegrationType.GOOGLE_TAG_MANAGER]:
    OrganizationIntegrationCategory.ANALYTICS,
  //crm
  [OrganizationIntegrationType.INSIGHTLY]: OrganizationIntegrationCategory.CRM,
  //payments
  [OrganizationIntegrationType.STRIPE]:
    OrganizationIntegrationCategory.PAYMENTS,
  // [OrganizationIntegrationType.BITLY]: OrganizationIntegrationCategory.OTHER,
  // [OrganizationIntegrationType.EVENTBRITE]:
  //   OrganizationIntegrationCategory.OTHER,

  // POS
  [OrganizationIntegrationType.RPOWER]: OrganizationIntegrationCategory.POS,
  [OrganizationIntegrationType.OMNIVORE]: OrganizationIntegrationCategory.POS,
  [OrganizationIntegrationType.SILVERWARE]: OrganizationIntegrationCategory.POS,
  [OrganizationIntegrationType.TOAST]: OrganizationIntegrationCategory.POS,
  [OrganizationIntegrationType.SQUARE]: OrganizationIntegrationCategory.POS,
  [OrganizationIntegrationType.BILLFOLD]: OrganizationIntegrationCategory.POS,
  [OrganizationIntegrationType.TABLELIST]:
    OrganizationIntegrationCategory.MARKETPLACE,
  [OrganizationIntegrationType.DISCOTECH]:
    OrganizationIntegrationCategory.MARKETPLACE,
  [OrganizationIntegrationType.CYMBAL]:
    OrganizationIntegrationCategory.MARKETPLACE,
  [OrganizationIntegrationType.SWIVUL]:
    OrganizationIntegrationCategory.MARKETPLACE,
}

export const OrganizationIntegrationCategoryToType: {
  [key in OrganizationIntegrationCategory]: OrganizationIntegrationType[]
} = {
  [OrganizationIntegrationCategory.PAYMENTS]: [
    OrganizationIntegrationType.STRIPE,
  ],
  [OrganizationIntegrationCategory.POS]: [
    OrganizationIntegrationType.RPOWER,
    OrganizationIntegrationType.OMNIVORE,
    OrganizationIntegrationType.SILVERWARE,
    OrganizationIntegrationType.TOAST,
    OrganizationIntegrationType.SQUARE,
    OrganizationIntegrationType.BILLFOLD,
  ],
  [OrganizationIntegrationCategory.ANALYTICS]: [
    OrganizationIntegrationType.FACEBOOK,
    OrganizationIntegrationType.GOOGLE_TAG_MANAGER,
  ],
  [OrganizationIntegrationCategory.CRM]: [
    OrganizationIntegrationType.INSIGHTLY,
  ],
  // [OrganizationIntegrationCategory.OTHER]: [
  //   OrganizationIntegrationType.BITLY,
  //   OrganizationIntegrationType.EVENTBRITE,
  // ],
  [OrganizationIntegrationCategory.MARKETING]: [
    OrganizationIntegrationType.HELIOS,
    OrganizationIntegrationType.MAILCHIMP,
  ],
  [OrganizationIntegrationCategory.MARKETPLACE]: [
    OrganizationIntegrationType.TABLELIST,
    OrganizationIntegrationType.DISCOTECH,
    OrganizationIntegrationType.CYMBAL,
    OrganizationIntegrationType.SWIVUL,
  ],
}
